import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { DRAM_LONG_DATES_GAP, PAIR_LAYOUT } from "../configs";
import { PlanningGridContext } from "../PlanningGrid";

const labelSx = { fontSize: "10px", fontFamily: "inherit", color: "#58627D" };

export const GridHeader = () => {
  const {
    headerGroups,
    headerGroupsDatesLayout,
    grid,
    isSelectionMode,
  } = useContext(PlanningGridContext);
  const [isSticky, setIsSticky] = useState(false);
  const sentinelRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: 0 }
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Box ref={sentinelRef} sx={{ height: 1 }} />

      <Box
        sx={{
          pb: 1,
          pt: 1,
          borderBottom: isSticky
            ? "1px solid #e0e0e0"
            : "1px solid transparent",
          position: "sticky",
          top: 0,
          bgcolor: isSticky ? "#FFF" : "transparent",
          transition: "background-color 0.3s ease",
          zIndex: 2,
          boxShadow: isSticky ? "0 2px 4px rgba(0,0,0,0.2)" : "none",
          pl: "16px",
          pr: "16px",
        }}
      >
        {/* PRIMEIRA LINHA DO HEADER (Grupos) */}
        <Box display="grid" gridTemplateColumns={grid}>
          {isSelectionMode && <Box />}
          <Box />
          {/* Sub-grid dos Títulos com Gap */}
          <Box
            display="grid"
            gridTemplateColumns={headerGroupsDatesLayout}
            gap={DRAM_LONG_DATES_GAP}
          >
            {headerGroups.map((group, index) => (
              <Box key={index} textAlign="center">
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontFamily: "inherit",
                    color: "#58627D",
                    fontWeight: "400",
                  }}
                >
                  {group.title}
                </Typography>
                <Box
                  sx={{
                    height: "1px",
                    bgcolor: "#58627D",
                    width: "85%",
                    margin: "2px auto",
                  }}
                />
              </Box>
            ))}
          </Box>
          <Box /> {/* Ações Vazias */}
        </Box>

        {/* SEGUNDA LINHA DO HEADER (Planejado / Entregue) */}
        <Box display="grid" gridTemplateColumns={grid}>
          {isSelectionMode && <Box />}
          <Box /> {/* Título Vazio */}
          {/* Sub-grid das labels com Gap */}
          <Box
            display="grid"
            gridTemplateColumns={headerGroupsDatesLayout}
            gap={DRAM_LONG_DATES_GAP}
          >
            {headerGroups.map((group, index) =>
              // Sub-grid interna do par
              group.hideSubLabels ? (
                <Box key={index} />
              ) : (
                <Box
                  key={index}
                  display="grid"
                  gridTemplateColumns={PAIR_LAYOUT}
                >
                  <Box textAlign="center">
                    <Typography variant="caption" sx={labelSx}>
                      PLANEJADO
                    </Typography>
                  </Box>

                  <Box textAlign="center">
                    <Typography variant="caption" sx={labelSx}>
                      ENTREGUE
                    </Typography>
                  </Box>
                </Box>
              )
            )}
          </Box>
          <Box /> {/* Ações Vazias */}
        </Box>
      </Box>
    </>
  );
};
